import { lazy } from "react";

export const ProjectsPortalView = lazy(() => import("./ProjectsPortalView"));
